import Vue from 'vue';

export var eventBus = new Vue();


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/event-bus.js
// module id = ./src/abstractions/event-bus.js
// module chunks = 34